<template>
  <div data-test-id="author-info" :data-test-name="entity.name">
    <ClockIcon16 v-if="icon" class="author-info__icon" />
    <i18n-t :keypath="createdPath" tag="span" scope="global">
      <template #name>
        {{ createdString }}
      </template>
      <template #timeAgo>
        <TimeSince :date="new Date(entity.createdAt)" />
      </template>
    </i18n-t>
    <br v-if="lineBreak" />
    <template v-else-if="showEntityUpdateTime">&nbsp;-&nbsp;</template>
    <i18n-t
      v-if="showEntityUpdateTime"
      :keypath="entity.updatedBy ? 'authorInfo.updatedBy' : 'authorInfo.updated'"
      tag="span"
      scope="global"
    >
      <template #name>
        {{ updatedString }}
      </template>
      <template #timeAgo>
        <TimeSince :date="new Date(entity.updatedAt)" />
      </template>
    </i18n-t>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import ClockIcon16 from '@components/Icons/ClockIcon16.vue';
import isSameDate from '@/util/isSameDate';

export default defineComponent({
  name: 'AuthorInfo',
  components: {
    ClockIcon16,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    entityType: {
      type: String,
      required: true,
    },
    lineBreak: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    createdString(): string {
      return this.getAuthorString(this.entity.createdBy);
    },
    updatedString(): string {
      return this.getAuthorString(this.entity.updatedBy);
    },
    createdPath(): string {
      return this.entity.createdBy
        ? `authorInfo.${this.entityType}.createdBy`
        : `authorInfo.${this.entityType}.created`;
    },
    showEntityUpdateTime(): boolean {
      return this.entity.updatedAt && !isSameDate(this.entity.createdAt, this.entity.updatedAt);
    },
  },
  methods: {
    getAuthorString(user: { isPlaceholder: boolean; firstname: string; fullname: string }) {
      if (!user) return null;

      if (user.isPlaceholder) return this.$t('placeholderUser', { name: user.firstname });

      return user.fullname || this.$t('deletedUser');
    },
  },
});
</script>

<style lang="scss">
.author-info__icon {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
}
</style>
